import { render, staticRenderFns } from "./ScoreboardQuestion.vue?vue&type=template&id=79cbdc48&"
import script from "./ScoreboardQuestion.vue?vue&type=script&lang=js&"
export * from "./ScoreboardQuestion.vue?vue&type=script&lang=js&"
import style0 from "./ScoreboardQuestion.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCard,VCardText,VIcon,VSimpleTable})
